import CardSystem from '../CardSystem';
import GameObject from '../../../GameObject/GameObject';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { UIEvent } from '../../UI/BaseUISystem';
import SpriteComponent from '../../../Component/Render/Sprite';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function ShuffleCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);
    PlaySound('shuffle');
    const targets: any[] = taskData.targets.map((target: any) => {
        const card = system.getCardByID(target.cardID);
        card
            .getChildByName('cardFrontSprite')
            .getComponent(SpriteComponent).texture = `card${target.oldValue +
            1}`;

        return {
            ...target,
            card,
        };
    });

    const shuffleAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(shuffleAnimator);

    system.taskQueue.queue(
        new CardAnimationTask(
            taskData,
            system,
            'BoosterShuffle',
            shuffleAnimator,
            {
                targets: targets,
            }
        )
    );
}
